const hostname = window.location.hostname;
const isLocal = hostname === 'localhost';
const isProd = hostname === 'tinymgr-dps.kone.com';

export const cognitoConfig = isProd
  ? {
      Domain: "tinymgr-prod",
      Region: "eu-west-1",
      UserPoolId: "eu-west-1_QOFnFmmUR",
      ClientId: "2ev6cbahkuq52hlc30i6n3kuas",
      IdentityProvider: "tinymanager-kone-sso-prod",
      RedirectUriSignIn: "https://tinymgr-dps.kone.com/logincallback",
      RedirectUriSignOut: "https://tinymgr-dps.kone.com/",
    }
  : {
      Domain: "tinymgr-qa",
      Region: "eu-west-1",
      UserPoolId: "eu-west-1_wlGHGBI93",
      ClientId: "3lqp5jgr60hogedqkmjv3pueq3",
      IdentityProvider: "tinymanager-kone-sso-qa",
      RedirectUriSignIn: isLocal
        ? "http://localhost:3000/logincallback"
        : "https://tinymgr-qa-dps.kone.com/logincallback",
      RedirectUriSignOut: isLocal
        ? "http://localhost:3000/"
        : "https://tinymgr-qa-dps.kone.com/",
    };
